export class URLs {

  // Auth
  static login = '/admin/auth/login';
  static applications = '/admin/company-applications';
  static acceptApplication = '/admin/company-application-status/approve';
  static rejectApplication = '/admin/company-application-status/reject';

}
